// 静态路由配置
// 书写格式与动态路由格式一致，全部经由框架统一转换
// 比较动态路由在meta中多加入了role角色权限，为数组类型。一个菜单是否有权限显示，取决于它以及后代菜单是否有权限。
// routes 显示在左侧菜单中的路由(显示顺序在动态路由之前)
// 示例如下

// const routes = [
// 	{
// 		name: "realTime",
// 		path: "/realTime",
// 		meta: {
// 			title: "实时监视",
// 			icon: "el-icon-Compass",
// 			type: "menu",
// 			isMap: "true"
// 		},
// 		component: "realTime",
// 	},
// 	{
// 		name: "playback",
// 		path: "/playback",
// 		meta: {
// 			title: "聚焦回放",
// 			icon: "el-icon-homeFilled",
// 			hidden: true,
// 			type: "menu",
// 			isMap: "true",
// 			active: 'playback_many'
// 		},
// 		component: "playback",
// 	},
// 	{
// 		name: "playback_many",
// 		path: "/playback_many",
// 		meta: {
// 			title: "历史回放",
// 			icon: "el-icon-Clock",
// 			type: "menu",
// 			isMap: "true"
// 		},
// 		component: "playback_many",
// 	},
// 	{
// 		name: "weather",
// 		path: "/weather",
// 		meta: {
// 			title: "气象咨询",
// 			icon: "el-icon-Sunrise",
// 			type: "menu",
// 			// isMap: "false"
// 		},
// 		component: "weather",
// 	}
// ]

const routes = []

export default routes;
